@if (!item.hidden && (isGrantedRole && (!item.isCoordenador || (item.isCoordenador && isCoordenador)))) {
  <!-- ALTERADO PELA PGE-RS: escondendo o APLICAÇÕES. -->
  @if (item.id !== 'applications') {
    <div class="group-title" [ngClass]="item.classes">
      <span class="hint-text" [translate]="item.translate">{{ item.title }}</span>
    </div>
  }
  <div class="group-items">
    @for (item of item.children; track item) {
      @if (item.type==='group') {
        <cdk-nav-vertical-group [item]="item"></cdk-nav-vertical-group>
      }
      @if (item.type==='collapsable') {
        <cdk-nav-vertical-collapsable
        [item]="item"></cdk-nav-vertical-collapsable>
      }
      @if (item.type==='item') {
        <cdk-nav-vertical-item [item]="item"></cdk-nav-vertical-item>
      }
    }
  </div>
}
